import {ChangeDetectorRef, Injectable} from '@angular/core';
import {Story} from "../../models/Story/Story";
import {BehaviorSubject, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {fromPromise} from "rxjs/internal-compatibility";
import {EnvironmentConfig} from "../../models/Story/EnvironmentConfig";
import {ImageryProviderService} from "../imageryProvider/imagery-provider.service";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {ConcreteLayerService} from "../concreteLayer/concrete-layer.service";
import {EsBsModalService} from "../bsModalService/bs-modal.service";
import {ToolsService} from "../toolsService/tools.service";
import {PreloadService} from "../preloadService/preload.service";
import {Overlay} from "../overlay/Overlay";
import {OverlayService} from "../overlay/overlay.service";
import {GroupService} from '../groupService/group-service.service';
import { AppComponent } from '@src/app/app.component';
import { TimelineService } from '../timeline/timeline.service';

@Injectable({
  providedIn: 'root'
})
export class StoryService {
  private _stories : Story[] = [];
  private _storiesUpdated$ = new Subject();
  private _currentStory$ = new BehaviorSubject(null);
  private _isScreenshotCreated$ = new Subject();
  private _changeStoryTabStatus$ = new BehaviorSubject(false);
  private environmentComponents = ['imageryProviderService', 'itemManagerService', 'concreteLayerService', 'overlayService'];
  public hiddenGroups:any = [];
  public forceHiddenGroups:any = true;
  public appComponent:AppComponent;

  private story_slide_count:any = {};
  public isOpened: boolean = false;
  private _inActivateEditMenu = new Subject();
  set inActivateEditMenu$(val){
    this._inActivateEditMenu.next(val);
  }

  get inActivateEditMenu$():any{
    return this._inActivateEditMenu.asObservable();
  }


  get labelVisibility(){
    return this.appComponent.isLabelsActive;
  }

  get changeStoryTabStatus$(){
    return this._changeStoryTabStatus$.asObservable();
  }

  get currentStory$(){
    return this._currentStory$.asObservable()
  }

  set currentStory$(val:any){
    this._currentStory$.next(val);
  }

  get currentStory(){
    return this._currentStory$.getValue();
  }

  get isScreenshotCreated$(){
    return this._isScreenshotCreated$.asObservable();
  }
  set isScreenshotCreated$(val:any){
    this._isScreenshotCreated$.next(val);
  }

  public currentImage;
  get storiesUpdated$(){
   return this._storiesUpdated$.asObservable();
  }
  get stories(){
    return this._stories;
  }

  set addStory(story: Story){
    this._stories.push(story);
    this._storiesUpdated$.next(this.stories);
  }

  set stories(stories:Story[]){
    this._stories = stories;
    this._storiesUpdated$.next(this.stories);
  }

  get nextSlideIdForCurrentStory(){
    let nextID:any = 0;
    if(typeof this.currentStory.slides !== 'undefined' && this.currentStory.slides && this.currentStory.slides.length > 0){
      nextID = this.currentStory.slides.length;
    }
    if(typeof this.story_slide_count[this.currentStory.id] !== 'undefined'){
      nextID = this.story_slide_count[this.currentStory.id];
    }
    nextID++;
    return nextID;

  }

  setCurrentImage(string){
    this.currentImage = string;
  }

  setCameraPositionToSlide(slide){
    let cameraPosition = this.cesiumAdapterService.getCameraPosition();
    slide.config.cameraLatitude = cameraPosition.latitude;
    slide.config.cameraLongitude = cameraPosition.longitude;
    slide.config.cameraHeight = cameraPosition.height;

    let cameraOrientation = this.cesiumAdapterService.getCameraOrientation();
    slide.config.cameraHeading = cameraOrientation.heading;
    slide.config.cameraPitch = cameraOrientation.pitch;
    slide.config.cameraRoll = cameraOrientation.roll;
  }

  // addSlideToStory(story:Story, slide){
  //   this.setSlideConfig(slide);
  //   let currentStory = this.getStoryById(story.id);
  //   currentStory.slides.push(slide);
  //   this.saveStory();
  // }

  async addSlideToStory(story:Story, slide){
    this.setCameraPositionToSlide(slide);
    let config:any = await this.getCurrentConfigAsync();
    config.bounds = await this.cesiumAdapterService.getViewRectangleAsync();
    slide.setEnvironment(config);
    // slide.setEnvironment(this.getCurrentConfig());
    let currentStory = this.getStoryById(story.id);
    currentStory.slides.push(slide);
    this.currentStory$ = currentStory;
    this.saveStory();
  }

  async setSlideConfig(slide) {
    this.setCameraPositionToSlide(slide);
    let config:any = await this.getCurrentConfigAsync();
    config.bounds = await this.cesiumAdapterService.getViewRectangleAsync();
    slide.setEnvironment(config);
  }

  getCurrentConfigAsync(){


    return new Promise((resolve, reject) => {
      let e = new EnvironmentConfig();
      let bounds_available:any = false;
      let timeline_available:any = false;
      this.environmentComponents.forEach((componentName) => {
        if (this.hasOwnProperty(componentName)) {
          e.addComponentConfig(componentName, this[componentName].getEnvironmentConfig());
        }
      });

      e.hiddenGroups = this.forceHiddenGroups ? this.groupService.getHiddenGroups : [];
      e.imageryMode = this.imageryProviderService.getSelectedMode();
      e.greyscale = this.cesiumAdapterService.isBwActive;

      e.labelsVisible = window['isLabelsActive'];

      this.timelineService.activeFrames.subscribe(frames => {
        timeline_available = true;
        e.timeline = {
          frames: frames,
          visible: this.timelineService.isActive,
          time: this.timelineService.timelineTime,
        };
        //if(timeline_available && bounds_available)
        resolve(e);
      });
        // resolve(e);
    });

  }

  getCurrentConfig(){
    let e = new EnvironmentConfig();
    this.environmentComponents.forEach((componentName) => {
      if (this.hasOwnProperty(componentName)) {
        e.addComponentConfig(componentName, this[componentName].getEnvironmentConfig());
      }
    });
    return e;
  }

  public getStoryById(id){
    for (let i = 0; i<this.stories.length; i++){
      if (id.toString() == this.stories[i].id.toString()){
        return this.stories[i];
      }
    }
    return null;
  }

  constructor(
    private httpClient: HttpClient,
    private cesiumAdapterService: CesiumAdapterService,
    private imageryProviderService: ImageryProviderService,
    private itemManagerService: ItemManagerService,
    private concreteLayerService: ConcreteLayerService,
    private overlayService: OverlayService,
    private timelineService: TimelineService,
    private groupService: GroupService
  ) {
    if (window['SAVE_FOLDER_VISIBILITY_FOR_SLIDE']) {
      this.environmentComponents.push('groupService');
    }
  }

  // saveStory(cb?){
  //   this.httpClient.post('/story/save-story', {
  //     event_id: window['EVENT_ID'],
  //     data: this.stories
  //   }).subscribe((result: []) => {
  //     console.log('result of saving story', result);
  //     this.stories = result.map((_story) => {
  //       return Story.fromConfig(_story);
  //     });
  //     console.log('stories', this.stories);
  //     if (cb){
  //       cb(result);
  //     }
  //   }, (e)=>{
  //     if (cb){
  //       cb(e);
  //     }
  //     throw new Error(e);
  //   });
  // }

  saveStory(cb?){
    // for(let i in this.stories){
    //   for(let s in this.stories[i].slides){
    //     //this.stories[i].slides[s].config.environment['hiddenGroups'] = this.hiddenGroups;
    //     delete this.stories[i].slides[s].config.environment.boundsSetupSubject;
    //     delete this.stories[i].slides[s].config.environment.boundsready;
    //   }
    // }

    this.httpClient.post('/story/save-story', {
      event_id: window['EVENT_ID'],
      data: this.stories
    }).subscribe((result: []) => {
      this.stories = result.map((_story:any) => {

        this.story_slide_count[_story.id] = _story.slides.length;

        if(typeof _story.status !== 'undefined' && _story.status == 'new'){
          this.currentStory$ = Story.fromConfig(_story);
        }

        return Story.fromConfig(_story);
      });
      if (cb){
        cb(result);
      }
    }, (e)=>{
      if (cb){
        cb(e);
      }
      throw new Error(e);
    });
  }

  removeStory(story: Story){
    return fromPromise(
      new Promise<void>((resolve, reject)=>{
          for (let i = 0; i < this.stories.length; i++){
            let curStory = this.stories[i];
            if (curStory.id.toString().toLowerCase() == story.id.toString().toLowerCase()){
              this.stories.splice(i, 1);
              this.saveStory(()=>{
                return resolve();
              });
              return;
            }
          }
          reject();
      })
    )
  }

    generateStoryCount(): number {
      let maxCount = 0;
      this.stories.forEach((story) => {
        const match = story.name.match(/Presentation-(\d+)/);
        if (match) {
          const count = parseInt(match[1], 10);
          if (count > maxCount) {
            maxCount = count;
          }
        }
      });
      return maxCount + 1;
    }

  generateStoryId(){
    let conjecturalStoryId = this.stories.length+1;
    let maxStoryId = 0;
    this.stories.forEach((_story)=>{
      if (parseFloat(_story.id) > maxStoryId) {maxStoryId = parseFloat(_story.id)}
    });

    if (maxStoryId >= conjecturalStoryId){
      conjecturalStoryId = maxStoryId+1;
    }
    return conjecturalStoryId;
  }

  toggleStoriesTab(){
    this._changeStoryTabStatus$.next(!this._changeStoryTabStatus$.getValue());
  }

  setStoriesTabStatus(flag){
    this._changeStoryTabStatus$.next(flag);
  }
}
